import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AIMessage } from './components/ai-message';
import { UserMessage } from './components/user-message';
import { ArrowUp } from 'iconsax-react';
import { ChatStyles } from './style';
import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../application/store/useStore';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './chat-styles.scss';
import { cleanChatAsync, getChatHistoryAsync, sendMessageAsync } from '../../../../application/features/chat/chatThunk';
import { downloadPdf } from '../../../../application/helpers/file-helper';
import { getDocumentProcessStatusAsync } from '../../../../application/features/proposal/proposalThunk';
import { useTranslation } from 'react-i18next';
import { formatDateDMY } from '../../../../infrastructure/helpers';
import { Box, Button, Chip, IconButton, Stack, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ProposalDocumentPopUp } from '../../proposals/view-proposal-docs';
import { ArrowOutward, Done } from '@mui/icons-material';
import ImageLoader from '../../../components/common/ImageLoader';
import { keyframes } from '@emotion/react';
const breathingKeyframes = keyframes({
    '0%': { opacity: 1 },
    '50%': { opacity: 0.4 },
    '100%': { opacity: 1 }
});
const TypingDots = () => {
    return (_jsxs("div", { className: 'typingdots', children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
};
export function ChatSection({ changeAnswerRequest, resetChangeAnswerRequest, onReferenceClick }) {
    const { t } = useTranslation();
    const typeMessage = t('typeAMessage');
    const theme = useTheme();
    const { allProposalDocs } = useAppSelector((state) => state.proposalDocs);
    const { allProposals, proposal } = useAppSelector((state) => state.proposal);
    const { chatResponse, chatHistory, cleanedChat, chatSetupResponse } = useAppSelector((state) => state.chat);
    const MAX_WORDS = 2;
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);
    const [searchParams] = useSearchParams();
    const proposalId = searchParams.get('id');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const [loadingMessageId, setLoadingMessageId] = useState(null);
    const [isCleaningChat, setIsCleaningChat] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [localChatHistory, setLocalChatHistory] = useState([]);
    const [sources, setSources] = useState([]);
    const [referenceSource, setReferencesource] = useState();
    const [processingMessage, setProcessingMessage] = useState('');
    const [currentProposal, setCurrentProposal] = useState();
    const chatContainerRef = useRef(null);
    const latestMessageRef = useRef(null);
    const [isClicked, setIsClicked] = useState(false);
    const truncateWithSuffix = (clausename, questionNumber, maxLength) => {
        const suffix = `(${questionNumber})`;
        // If clausename is 20 characters or less, keep it as is
        if (clausename.length <= 20) {
            return clausename + ' ' + suffix;
        }
        // Otherwise, apply truncation logic
        if (clausename.length + suffix.length <= maxLength) {
            return clausename + ' ' + suffix;
        }
        const truncated = clausename.slice(0, maxLength - suffix.length - 3) + '...';
        return truncated + ' ' + suffix;
    };
    const handleClick = () => {
        setIsClicked(!isClicked);
    };
    const isDisabled = currentProposal?.some((x) => x.completionStatus === 0);
    useEffect(() => {
        if (latestMessageRef.current) {
            latestMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [localChatHistory]);
    useEffect(() => {
        if (proposalId) {
            dispatch(getChatHistoryAsync(proposalId));
            dispatch(getDocumentProcessStatusAsync({ background: true }));
            // Poll every 25 seconds to check document processing status
            const intervalId = setInterval(() => {
                dispatch(getDocumentProcessStatusAsync({ background: true }));
            }, 25000); // 25 seconds
            // Cleanup interval on component unmount
            return () => clearInterval(intervalId);
        }
    }, [dispatch, proposalId, cleanedChat]);
    useEffect(() => {
        if (chatHistory?.messages?.length) {
            setLocalChatHistory(chatHistory.messages);
        }
    }, [chatHistory, cleanedChat]);
    useEffect(() => {
        setCurrentProposal(allProposals?.filter((x) => x.id === proposalId));
    }, [allProposals]);
    const sendMessage = () => {
        if (inputValue.trim() === '')
            return;
        const newMessage = {
            message_id: `${Date.now()}`,
            question: inputValue,
            question_intent: '',
            question_type: 'text',
            answer: '',
            references: [],
            question_time: new Date().toISOString(),
            answer_time: ''
        };
        setLocalChatHistory((prevHistory) => [...prevHistory, newMessage]);
        setLoadingMessageId(newMessage.message_id);
        const isClauseUpdate = changeAnswerRequest !== null;
        // Build the message request
        const messageRequest = {
            ProposalId: proposalId,
            Question: inputValue,
            QuestionType: 'text',
            QuestionIntent: isClauseUpdate ? 'clause_update' : 'query',
            ActivateKB: isClicked,
            ClauseId: isClauseUpdate && changeAnswerRequest ? changeAnswerRequest.ClauseId : '',
            QuestionId: isClauseUpdate && changeAnswerRequest ? changeAnswerRequest.QuestionId : ''
        };
        console.log('changeAnswerRequest:', changeAnswerRequest);
        console.log('messageRequest:', messageRequest);
        dispatch(sendMessageAsync(messageRequest))
            .unwrap()
            .then((response) => {
            console.log('Message sent successfully:', response);
            setSources(response.sources);
            if (isClauseUpdate) {
                resetChangeAnswerRequest();
            }
        })
            .catch((error) => {
            console.error('Failed to send message:', error);
        });
        setInputValue('');
    };
    // useEffect(() => {
    //   const updatedChatHistory = [...localChatHistory];
    //   const lastMessage = updatedChatHistory[updatedChatHistory.length - 1];
    //   if (chatResponse) {
    //     const updatedChatHistory = [...localChatHistory];
    //     const lastMessage = updatedChatHistory[updatedChatHistory.length - 1];
    //     lastMessage.answer = chatResponse.response ? chatResponse.response : '';
    //     lastMessage.answer_time = new Date().toISOString();
    //     setLocalChatHistory(updatedChatHistory);
    //     setLoadingMessageId(null);
    //   }
    // }, [chatResponse]);
    useEffect(() => {
        dispatch(getDocumentProcessStatusAsync({ background: true }));
        if (chatResponse && localChatHistory.length > 0) {
            setLocalChatHistory((prevHistory) => {
                const updatedChatHistory = [...prevHistory];
                const lastMessageIndex = updatedChatHistory.length - 1;
                // Ensure we don't mutate state directly
                updatedChatHistory[lastMessageIndex] = {
                    ...updatedChatHistory[lastMessageIndex],
                    answer: chatResponse.response ?? '',
                    answer_time: new Date().toISOString(),
                    references: chatResponse.sources ?? []
                };
                return updatedChatHistory;
            });
            setLoadingMessageId(null);
        }
    }, [chatResponse, navigate]);
    const cleanChat = () => {
        if (proposalId && chatHistory) {
            setIsCleaningChat(true);
            const cleanRequest = {
                ProposalId: proposalId,
                ConversationId: chatHistory?.conversation_id
            };
            dispatch(cleanChatAsync(cleanRequest))
                .unwrap()
                .finally(() => {
                setIsCleaningChat(false);
            });
        }
    };
    const downloadChat = () => {
        if (proposalId && chatResponse) {
            const downloadChatRequest = {
                ProposalId: proposalId,
                ConversationId: chatResponse?.conversation_id
            };
            downloadPdf(downloadChatRequest.ProposalId, downloadChatRequest.ConversationId, 'pdf', dispatch);
        }
        return;
    };
    const ThinkingAndAnalyzingLoader = ({ isAiThinking = false }) => {
        if (isAiThinking) {
            // replacement of dotLoader
            return (_jsx(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '8px !important',
                    animation: `${breathingKeyframes} 1.5s ease-in-out infinite`,
                    animationDuration: '1.5s',
                    animationTimingFunction: 'ease-in-out',
                    animationIterationCount: 'infinite',
                    color: theme.palette.text.primary
                }, children: _jsxs("span", { children: [t('thinkingAnalysing'), "..."] }) }));
        }
        // Processing document section
        if (!currentProposal?.some((x) => x.completionStatus === 0))
            return _jsx(_Fragment, {});
        return (_jsxs(Box, { sx: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '8px !important',
                animation: `${breathingKeyframes} 1.5s ease-in-out infinite`,
                animationDuration: '1.5s',
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite',
                color: theme.palette.text.primary
            }, children: [!isAiThinking && _jsx(ImageLoader, { height: '40px', width: '40px' }), currentProposal?.some((x) => x.completionStatus !== 0) && (_jsxs("span", { children: [t('thinkingAnalysing'), "..."] })), isAiThinking &&
                    currentProposal?.map((x, index) => {
                        const statusText = x.status || ''; // Ensure it's always a string
                        const words = statusText.split(' ');
                        const truncatedStatus = words.slice(0, 4).join(' '); // First 4 words
                        return (_jsxs("span", { style: { color: theme.palette.text.primary }, children: [truncatedStatus, words.length > 4 && (_jsx("span", { title: x.status, style: { cursor: 'pointer' }, children: "..." }) // Ellipsis with full status on hover
                                )] }, index));
                    })] }));
    };
    const handleReferenceClick = (source, sources) => {
        onReferenceClick(source, sources);
    };
    return (_jsxs(_Fragment, { children: [isDocumentPopupOpen && (_jsx(ProposalDocumentPopUp, { proposalName: t('chatDocuments') || 'Default Chat Documents', openProposalDocumentDialog: isDocumentPopupOpen, onClose: () => setIsDocumentPopupOpen(false), files: allProposalDocs || [] })), _jsxs(Stack, { sx: {
                    height: 'calc(100svh - 110px)',
                    borderRadius: 2,
                    padding: 2,
                    backgroundColor: theme.palette.background.paper,
                    boxShadow: theme.customShadows.card
                }, children: [isDisabled && (_jsxs(Box, { sx: {
                            backgroundColor: theme.palette.warning.lighter,
                            border: `1px solid ${theme.palette.warning.main}`,
                            borderRadius: 1,
                            padding: 2,
                            marginBottom: 2,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }, children: [_jsx(ImageLoader, { height: '24px', width: '24px' }), _jsx(Typography, { variant: 'body2', color: theme.palette.warning.dark, children: t('proposalProcessingMessage') ||
                                    'Proposal documents are still being processed. Chat will be available shortly. Please wait...' })] })), _jsxs(Stack, { flexDirection: 'row', sx: {
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            gap: '8px'
                        }, children: [_jsxs(Box, { height: '100%', display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'flex-start', marginLeft: isBelowLg ? 5 : 0, children: [_jsx(Typography, { variant: 'h4', color: theme.palette.text.primary, children: t('chat') }), _jsx(Typography, { variant: 'h4', alignItems: 'center', color: theme.palette.text.secondary, children: '(' + (chatSetupResponse?.conversation_name || currentProposal?.[0]?.projectName || 'No Project Name') + ')' })] }), _jsx(Stack, { flexDirection: 'row', alignItems: 'center', sx: { gap: '8px', marginLeft: 'auto' }, children: _jsx("div", { style: ChatStyles.documentButton, children: _jsx(Button, { onClick: () => setIsDocumentPopupOpen(true), endIcon: _jsx(ArrowOutward, {}), variant: 'contained', size: 'medium', sx: {
                                            background: 'linear-gradient(136deg, var(--primary-light, #5EE2EC) -31.76%, var(--primary-main, #009CA7) 84.18%)',
                                            color: '#fff',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                background: 'linear-gradient(136deg, var(--primary-light, #5EE2EC) -31.76%, var(--primary-main, #009CA7) 84.18%)',
                                                opacity: 0.9
                                            }
                                        }, children: t('files') }) }) })] }), _jsxs(Box, { style: {
                            height: 'calc(100svh - 190px)',
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '14px',
                            justifyContent: 'space-between'
                        }, children: [_jsx(Box, { ref: chatContainerRef, style: {
                                    flex: 1,
                                    overflowY: 'auto',
                                    borderRadius: 1,
                                    padding: '0px 4px 0px 0px'
                                }, children: _jsx(Stack, { gap: 2, children: localChatHistory?.map((msg, index) => (_jsx(_Fragment, { children: _jsxs("div", { ref: index === localChatHistory.length - 1 ? latestMessageRef : null, style: { gap: 24 }, children: [msg.question && (_jsx(UserMessage, { content: msg.question, timestamp: formatDateDMY(msg.question_time) }, `user-${index}`)), _jsx(AIMessage, { onReferenceClick: handleReferenceClick, sources: msg.references, content: msg.answer ? (msg.answer) : (_jsx(ThinkingAndAnalyzingLoader, { isAiThinking: !Boolean(msg?.answer) })), timestamp: msg.answer_time ? formatDateDMY(msg.answer_time) : '' }, `ai-${index}`)] }, `message-${index}`) }))) }) }), _jsxs(Stack, { sx: {
                                    backgroundColor: theme.palette.background.paper,
                                    boxShadow: theme.customShadows.card,
                                    borderRadius: 2
                                }, position: 'relative', gap: '10px', p: 2, children: [changeAnswerRequest && (_jsx(Tooltip, { title: changeAnswerRequest.ClauseName, placement: 'top', children: _jsx(Chip, { label: truncateWithSuffix(changeAnswerRequest.ClauseName || '', `Q${changeAnswerRequest.QuestionNo}`, 2), onDelete: resetChangeAnswerRequest, className: 'custom-tag', size: 'small', variant: 'outlined', sx: {
                                                maxWidth: '300px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            } }) })), _jsx(Stack, { flexDirection: 'row', sx: { gap: 8 }, children: _jsx(TextField, { variant: 'standard', multiline: true, rows: 2, sx: {
                                                width: '100%',
                                                '& .MuiInputBase-root-MuiOutlinedInput-root': { border: 'none' }
                                            }, placeholder: typeMessage, value: inputValue, onChange: (e) => setInputValue(e.target.value), onKeyDown: (e) => e.key === 'Enter' && sendMessage(), disabled: loadingMessageId !== null || isDisabled }) }), _jsxs(Stack, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', children: [_jsx(Button, { size: 'medium', color: 'primary', variant: isClicked ? 'soft' : 'outlined', startIcon: isClicked ? _jsx(Done, {}) : undefined, onClick: handleClick, sx: {
                                                    border: isClicked ? `1px solid ${theme.palette.primary.main}99` : undefined,
                                                    color: theme.palette.primary.main,
                                                    '&:hover': {
                                                        backgroundColor: theme.palette.background.neutral,
                                                        borderColor: theme.palette.primary.main
                                                    }
                                                }, children: t('knowledgeBase') }), _jsx(IconButton, { size: 'small', color: 'primary', sx: {
                                                    background: 'linear-gradient(135deg, var(--primary-light, #00B6C7) 0%, var(--primary-main, #008996) 100%)',
                                                    border: `1px solid ${theme.palette.action.disabled}`,
                                                    '&.Mui-disabled': {
                                                        background: theme.palette.action.disabledBackground,
                                                        borderColor: theme.palette.action.disabled
                                                    }
                                                }, onClick: sendMessage, disabled: loadingMessageId !== null || inputValue.trim() === '' || isDisabled, children: _jsx(ArrowUp, { color: loadingMessageId !== null || inputValue.trim() === ''
                                                        ? theme.palette.action.disabled
                                                        : theme.palette.primary.contrastText }) })] })] })] })] })] }));
}
